import React from 'react';
import MainPage from './Pages/MainPage'; // Import the MainPage component
import NavBar from './components/NavBar'; // Import the NavBar component
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <NavBar />
      <main>
        <MainPage />
      </main>
      <Footer />
    </div>
  );
}

export default App;